import { v7 as uuidv7 } from 'uuid';

import { COLUMN_SPAN_DEFAULT } from '@/lib/blocks/tree';
import { getBlockUiKey, type PageBlock } from '@/types/block';

export type DefaultBlockInput = Partial<PageBlock> & {
  children?: DefaultBlockInput[];
} & Record<string, unknown>;

export function normalizeDefaultBlocks(blocks: DefaultBlockInput[]): PageBlock[] {
  const normalizedBlocks: PageBlock[] = [];

  const appendBlocks = (entries: DefaultBlockInput[], parentBlockId: string | null) => {
    entries.forEach((entry, index) => {
      const blockType = typeof entry.blockType === 'string' ? entry.blockType : undefined;
      if (!blockType) {
        return;
      }

      const blockId = typeof entry.id === 'string' ? entry.id : uuidv7();
      const position =
        typeof entry.position === 'number' && Number.isFinite(entry.position)
          ? Math.trunc(entry.position)
          : index + 1;
      const columnSpan =
        typeof entry.columnSpan === 'number' && Number.isFinite(entry.columnSpan)
          ? Math.trunc(entry.columnSpan)
          : COLUMN_SPAN_DEFAULT;
      const visible = typeof entry.visible === 'boolean' ? entry.visible : true;
      const props =
        entry.props && typeof entry.props === 'object' && !Array.isArray(entry.props)
          ? entry.props
          : {};

      normalizedBlocks.push({
        id: blockId,
        uiKey: getBlockUiKey({ id: blockId }),
        blockType: blockType as PageBlock['blockType'],
        props,
        parentBlockId,
        columnSpan,
        position,
        visible,
      });

      const children = Array.isArray(entry.children) ? entry.children : [];
      if (children.length > 0) {
        appendBlocks(children, blockId);
      }
    });
  };

  appendBlocks(blocks, null);
  return normalizedBlocks;
}
